import { Button } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ContractTaskDto } from '../../../autogen/bff-api'
import { Tooltip } from '../../../common/components/Tooltip'
import { urls } from '../../../urls'

interface Props {
    task: ContractTaskDto
    size?: 'sm' | 'md' | 'lg'
}

export const ContractTitle: React.FC<Props> = ({ task }) => {
    const navigate = useNavigate()

    return (
        <Tooltip label={task.contractTitle} openDelay={300}>
            <Button
                variant="link"
                display="block"
                width="full"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                textAlign="start"
                size="sm"
                colorScheme={'blue'}
                onClick={() => {
                    navigate(urls.app.contracts.view.go(task.contractId))
                }}
            >
                {task.contractTitle}
            </Button>
        </Tooltip>
    )
}
